import { ResponseError } from "../../../dto/Error.dto";
import { showErrorToast } from "./Toast";

export const showErrorResponse = (error: ResponseError) => {
    if (error.responseCode) {
        if (error.responseCode.toString() === "1" && error.message) {
            showErrorToast(error.message);
        } else if (error.responseCode.toString() === "-1") {
            return;
        }
    } else {
        showErrorToast("Something went wrong! please try again later");
    }

}